export default defineNuxtRouteMiddleware(async (to, from) => {
  const supabase = useSupabaseClient()
  const { checkRole } = useRoles()
  
  console.log('Admin middleware running, checking auth state...')
  
  try {
    // First check if we have a valid session
    const { data: { session }, error: sessionError } = await supabase.auth.getSession()
    
    if (sessionError) {
      console.error('Admin middleware: Session error:', sessionError.message)
      return navigateTo({
        path: '/login',
        query: { 
          redirect: to.fullPath,
          error: 'Authentication error: ' + sessionError.message
        },
        replace: true
      })
    }
    
    // No session means not logged in
    if (!session) {
      console.log('Admin middleware: No valid session')
      return navigateTo({
        path: '/login',
        query: { 
          redirect: to.fullPath,
          error: 'You must be logged in to access this page'
        },
        replace: true
      })
    }
    
    // Verify the user with getUser
    const { data: { user: authUser }, error: userError } = await supabase.auth.getUser()
    
    if (userError || !authUser) {
      console.error('Admin middleware: User verification error:', userError?.message || 'No user data')
      return navigateTo({
        path: '/login',
        query: { 
          error: 'Authentication error: ' + (userError?.message || 'Invalid session')
        },
        replace: true
      })
    }
    
    // Check if user has admin role
    const { isAdmin, role } = await checkRole(true)
    console.log('Admin middleware: Role check result:', { isAdmin, role })
    
    if (!isAdmin) {
      console.log('Admin middleware: User is not an admin, redirecting with error message')
      return navigateTo({
        path: '/login',
        query: { 
          error: 'You need administrator privileges to access this page'
        },
        replace: true
      })
    }
    
    console.log('Admin middleware: Admin access granted')
  } catch (error) {
    console.error('Admin middleware: Error during authentication check:', error.message)
    return navigateTo({
      path: '/login',
      query: { 
        error: 'Authentication error: ' + error.message
      },
      replace: true
    })
  }
}) 